import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CDFTService } from 'app/modules/cdft/services/cdft.service';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';
import modules from 'app/modules/cdft/cdft.module';

@Component({
    selector: 'wellhead-subsidence',
    templateUrl: './wellhead-subsidence.component.html',
    standalone: true,
    styleUrls: ['./wellhead-subsidence.component.scss'],
    imports: modules,
})
export class WellheadSubsidenceComponent {
    @Input() isViewOnly: boolean;
    formGroup: FormGroup;

    observable$ = {
        cdftState: null,
    };

    constructor(
        private formBuilder: FormBuilder,
        private state: CDFTState,
        public service: CDFTService
    ) {}

    ngOnInit() {
        this.formGroup = this.onFormGroup();
        this.state.setFormGroup('cdftSubsidenceMonitoring', this.formGroup);

        this.onPopulate();
    }

    ngOnDestroy() {
        for (const key in this.observable$) {
            this.observable$[key]?.unsubscribe();
        }
    }

    onPopulate() {
        this.observable$.cdftState = this.state.subscribe((cdft: CDFTState) => {
            if (!cdft.cdftSubsidenceMonitoring) return;

            this.formGroup.patchValue(cdft.cdftSubsidenceMonitoring);
        });
    }

    onFormGroup() {
        return this.formBuilder.group({
            id: new FormControl({ value: null, disabled: true }),
            cdftRecordId: new FormControl({ value: null, disabled: true }),
            pcvPoint1: new FormControl({
                value: null,
                disabled: this.isViewOnly,
            }),
            icvPoint2: new FormControl({
                value: null,
                disabled: this.isViewOnly,
            }),
            scvPoint2: new FormControl({
                value: null,
                disabled: this.isViewOnly,
            }),
            ccvPoint3: new FormControl({
                value: null,
                disabled: this.isViewOnly,
            }),
            result: new FormControl({
                value: 'Normal',
                disabled: this.isViewOnly,
            }),
            remark: new FormControl({ value: null, disabled: this.isViewOnly }),
        });
    }
}
